<div *ngIf="client">
  <lms-breadcrumb [label]="client.name"></lms-breadcrumb>

  <div class="gl-context-menu__position">
    <lms-button-actions *ngIf="buttonList.length > 0" [items]="buttonList" (change)="selectAction($event)">
    </lms-button-actions>
  </div>

  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="setTab($event)"
    [(selectedIndex)]="selectedTab"
  >
    <mat-tab *lmsProfileGuard="'clients.client.dashboard'" label="dashboard">
      <ng-template mat-tab-label>
        <div data-testid="clientDashboardTab">{{ 'nouns.dashboard' | translate }}</div>
      </ng-template>
      <ng-template matTabContent>
        <lms-dashboard [client]="client"></lms-dashboard>
      </ng-template>
    </mat-tab>
    <mat-tab label="data">
      <ng-template mat-tab-label> {{ 'nouns.data' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-client-editor
          [client]="client"
          [catalogueData]="catalogueData"
          (onSave)="onUpdateClient($event)"
        ></lms-client-editor>
      </ng-template>
    </mat-tab>

    <ng-container *ngIf="subscriptionsCreditsEnabled">
      <mat-tab *lmsProfileGuard="'credits.list'" data-testid="clientCreditsTab" label="credits">
        <ng-template mat-tab-label> {{ 'subscriptions.credits' | translate }} </ng-template>
        <ng-template matTabContent>
          <lms-toolbar [options]="{ list: { listId: clientCreditslistId } }">
            <div *lmsProfileGuard="'credits.order'" tools-actions>
              <gl-button
                icon
                icon-center="glicon-dollar"
                [routerLink]="['/payments/order-credits']"
                [queryParams]="{ clientId: client.id }"
                title="{{ 'credits.order.label' | translate }}"
              >
              </gl-button>
            </div>
            <div *lmsProfileGuard="'credits.download-report'" tools-actions>
              <gl-button
                icon
                icon-center="glicon-download"
                (onClick)="downloadClientCreditsReport()"
                title="{{ 'credits.downloadReport' | translate }}"
              >
              </gl-button>
            </div>
            <div *lmsProfileGuard="'credits.assign'" class="lms-toolbar__item">
              <lms-broker-credits-dealer
                *ngIf="clientDistributor"
                [client]="client"
                [transactionType]="dealerService.CREDITS_SALE"
                [distributor]="clientDistributor"
                (transactionCompleted)="onTransactionCompleted()"
              ></lms-broker-credits-dealer>
            </div>
            <div *lmsProfileGuard="'credits.create'" tools-actions class="lms-toolbar__item">
              <gl-button
                color-primary
                [queryParams]="{ clientId: client.id }"
                title="{{ 'credits.create' | translate }}"
                [text]="'credits.create' | translate"
                [routerLink]="['/credits/new']"
              ></gl-button>
            </div>
          </lms-toolbar>
          <lms-client-credits
            #clientCreditsResume
            [client]="client"
            [updatedCredits]="updatedCredits"
            [listId]="clientCreditslistId"
          >
          </lms-client-credits>
          <lms-credits-list
            [client]="client"
            [listId]="clientCreditslistId"
            [updatedCredits]="updatedCredits"
            [type]="'credits'"
            (subscriptionChanged)="clientCreditsResume.loadClientCreditsResume()"
            [options]="{ active: !tabsToLoad.has('credits') }"
          ></lms-credits-list>
        </ng-template>
      </mat-tab>
    </ng-container>

    <ng-container *ngIf="subscriptionsUsersEnabled">
      <mat-tab *lmsProfileGuard="'subscriptions.list'" data-testid="clientSubscriptionTab" label="subscription">
        <ng-template mat-tab-label> {{ 'subscriptions.pageLabels.main' | translate }} </ng-template>
        <ng-template matTabContent>
          <lms-dynamic-form-error [formError]="errorSaveSubscription"></lms-dynamic-form-error>
          <lms-client-subscriptions (formErrorEmit)="setErrorMessage($event)"></lms-client-subscriptions>
        </ng-template>
      </mat-tab>
    </ng-container>

    <mat-tab *lmsProfileGuard="'clients.courses'" data-testid="clientCoursesTab" label="courses">
      <ng-template mat-tab-label> {{ 'catalog.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-courses listId="CLIENT_COURSES_LIST" [client]="client" scope="client"></lms-courses>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'clients.itineraries'" data-testid="clientItinerariesTab" label="itineraries">
      <ng-template mat-tab-label> {{ 'itineraries.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-itineraries listId="CLIENT_ITINERARIES_LIST" [client]="client" scope="client"></lms-itineraries>
      </ng-template>
    </mat-tab>

    <mat-tab label="classes" data-testid="clientClassesTab">
      <ng-template mat-tab-label> {{ 'groups.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-client-classes [listId]="clientGroupslistId" [client]="client"></lms-client-classes>
      </ng-template>
    </mat-tab>

    <mat-tab label="students" data-testid="clientStudentsTab">
      <ng-template mat-tab-label> {{ 'students.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-students
          [hideTitle]="true"
          [showActions]="true"
          [listId]="clientStudentslistId"
          [options]="{
            filters: filters,
            sort: 'email'
          }"
        ></lms-students>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'training.ranking.client'" label="ranking">
      <ng-template mat-tab-label> {{ 'ranking.title' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-ranking-list [client]="client"></lms-ranking-list>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'clients.sso'" data-testid="clientIntegrationTab" label="sso">
      <ng-template mat-tab-label> {{ 'clients.config.sso.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-client-sso [client]="client" (saved)="onUpdateSsoConfig($event)"></lms-client-sso>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'techTests.list'" data-testid="clientTechTestTab" label="techTests">
      <ng-template mat-tab-label> {{ 'techTests.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-tech-test [client]="client"></lms-tech-test>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'clients.admins'" data-testid="clientAgentsTab" label="agents">
      <ng-template mat-tab-label> {{ 'agents.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-client-agents [listId]="agentsClientlistId" [client]="client"></lms-client-agents>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'kepler.list'" label="kepler" data-testid="clientKeplerTab">
      <ng-template mat-tab-label> {{ 'Kepler' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-client-kepler-detail [client]="client"></lms-client-kepler-detail>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <!-- client delete -->
  <lms-client-delete #clientDelete [client]="client" (delete)="onDelete()"></lms-client-delete>
</div>

<!-- link to stripe modal -->
<lms-modal #ownerAgentSelector size="small">
  <div class="gl-popup__title margin-bottom">{{ 'actions.selectOwner' | translate }}</div>
  <lms-dynamic-form
    [questions]="ownerAgentQuestion"
    (submit)="stripe($event)"
    [options]="{ showSpinnerUponSubmitting: false, disableCard: true }"
  >
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="ownerAgentSelector.close()"
      form-actions-before
    ></gl-button>
  </lms-dynamic-form>
</lms-modal>
